ready(function () {

  const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
    if (prevBtn) {
      prevBtn.addEventListener('click', embla.scrollPrev, false);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', embla.scrollNext, false);
    }    
  };

  const setupPagination = (pagination, embla) => {
    if (pagination) {
      const updatePagination = () => {
        const selectedIndex = embla.selectedScrollSnap();
        pagination.innerHTML = `${selectedIndex + 1} / ${embla.slideNodes().length}`;
      };
      embla.on('init', updatePagination);
      embla.on('select', updatePagination);
      embla.on('resize', updatePagination);
    }
  };

  const updateActiveSlide = (embla) => {
    const slides = embla.slideNodes();
    const setActiveSlide = () => {
      slides.forEach(slide => slide.classList.remove('embla__slide--active'));
      const selectedIndex = embla.selectedScrollSnap();
      slides[selectedIndex].classList.add('embla__slide--active');
    };
    embla.on('init', setActiveSlide);
    embla.on('select', setActiveSlide);
  };  

  const setupSliderMatrixHeight = (emblaNode, embla) => {
    if (!emblaNode.classList.contains('type--sliderMatrix')) return;

    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const container = emblaNode.querySelector('.embla__viewport');
    let frame = null;

    if (!container) return;

    const refreshHeight = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        if (!mobileQuery.matches) {
          container.style.height = '';
          return;
        }

        const selectedIndex = embla.selectedScrollSnap();
        const selectedSlide = embla.slideNodes()[selectedIndex];
        if (selectedSlide) {
          container.style.height = selectedSlide.offsetHeight + 'px';
        }
      });
    };

    emblaNode.querySelectorAll('img').forEach(image => {
      image.addEventListener('load', refreshHeight);
      image.addEventListener('error', refreshHeight);
      if (image.complete) refreshHeight();
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshHeight);
    }

    embla.on('select', refreshHeight);
    embla.on('init', refreshHeight);
    embla.on('resize', refreshHeight);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', refreshHeight);
    } else {
      mobileQuery.addListener(refreshHeight);
    }
    window.addEventListener('load', refreshHeight, { once: true });
    window.addEventListener('resize', refreshHeight);
    window.addEventListener('orientationchange', refreshHeight);
  };

  const setupEmblaCarousel = (emblaNode) => {
    const viewPort = emblaNode.querySelector(".embla__viewport");
    const prevBtn = emblaNode.querySelector(".embla__button--prev");
    const nextBtn = emblaNode.querySelector(".embla__button--next");
    const pagination = emblaNode.querySelector(".embla__pagination");
    const isEntry10765 = document.body.classList.contains('entryId--10765');
    const screensSliderDelay = isEntry10765 ? 3600000 : 8000;

    // Define options and autoplay configuration based on slider type
    let options = { align: 'start' };
    let autoplayOptions = {};
    let useFade = false;

    if (emblaNode.classList.contains('type--sliderMatrix')) {
        options = { align: 'start', loop: false, containScroll: false };
        autoplayOptions = { playOnInit: true, delay: 8000 };
        useFade = true;
    } else if (emblaNode.classList.contains('type--hotNews')) {
        options = {
          align: 'start',
          loop: true,
          breakpoints: {
            '(max-width: 768px)': { active: false }
          }
        };
        autoplayOptions = { playOnInit: false };
    } else if (emblaNode.classList.contains('type--screensSlider')) {
      options = { align: 'start', loop: true};
      autoplayOptions = { playOnInit: true, delay: screensSliderDelay };
    }

    // Instantiate the autoplay plugin separately to keep a reference
    const autoplayPlugin = EmblaCarouselAutoplay(autoplayOptions);

    const plugins = [autoplayPlugin];

    if (useFade && typeof EmblaCarouselFade === 'function') {
      const fadePlugin = EmblaCarouselFade();
      plugins.push(fadePlugin);
    }

    // Create the Embla carousel with the plugins
    const embla = EmblaCarousel(viewPort, options, plugins);

    // Setup navigation and pagination
    setupSliderMatrixHeight(emblaNode, embla);
    setupPrevNextBtns(prevBtn, nextBtn, embla);
    setupPagination(pagination, embla);
    updateActiveSlide(embla);

    const cleanupVideo = (video) => {
      if (!video) return;

      video.pause();

      if (!video.loop) {
        video.currentTime = 0;
      }

      if (video._onVideoEnded) {
        video.removeEventListener('ended', video._onVideoEnded);
        delete video._onVideoEnded;
      }
    };

    const cleanupInactiveVideos = (activeVideo) => {
      emblaNode.querySelectorAll('video').forEach(video => {
        if (video !== activeVideo) {
          cleanupVideo(video);
        }
      });
    };

    const stopAutoplayAfterSelect = () => {
      window.setTimeout(() => {
        autoplayPlugin.stop();
      }, 0);
    };

    const handleSlideChange = () => {
        const selectedIndex = embla.selectedScrollSnap();
        const selectedSlide = embla.slideNodes()[selectedIndex];
        const isVideoSlide = selectedSlide.classList.contains('slide__video');
        const video = selectedSlide.querySelector('video');
        const totalSlides = embla.slideNodes().length;
        const isSingleVideoSlide = isVideoSlide && totalSlides === 1;

        cleanupInactiveVideos(video);

        if (isSingleVideoSlide) {
            // Special case: only one video slide → loop forever
            stopAutoplayAfterSelect();
            video.loop = true;
            video.currentTime = 0;
            video.play();
        } else if (isVideoSlide) {
            stopAutoplayAfterSelect();
            video.loop = false;

            if (video.readyState >= 1) {
                waitForVideoEnd(video);
            } else {
                video.addEventListener('loadedmetadata', () => {
                    waitForVideoEnd(video);
                }, { once: true });
            }

            video.currentTime = 0;
            video.play();
        } else {
            autoplayPlugin.play();
        }
    };


    // Wait for video to finish then resume autoplay and move to next slide
    const waitForVideoEnd = (video) => {
      // Supprime tout listener existant pour éviter les doublons
      video.removeEventListener('ended', video._onVideoEnded);

      // Crée un handler réutilisable et l'attache à l'élément
      const onVideoEnded = () => {
        embla.scrollNext();
      };

      video._onVideoEnded = onVideoEnded; // Mémoriser la référence
      video.addEventListener('ended', onVideoEnded);
    };

    // Bind events
    if (emblaNode.classList.contains('type--screensSlider')) {
      embla.on('init', handleSlideChange);
      embla.on('select', handleSlideChange);
    }
  };


  const emblaNodes = [].slice.call(document.querySelectorAll(".embla"));
  const emblaCarousels = emblaNodes.map(emblaNode => setupEmblaCarousel(emblaNode));

});
